/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Filter',
  definitions: {
    '16': {
      viewBox: '0 0 14 14',
      path: (
        <>
          <path
            d="M3.81812 4.85909C3.51436 4.85909 3.26812 5.10533 3.26812 5.40909C3.26812 5.71285 3.51436 5.95909 3.81812 5.95909L10.1818 5.95909C10.4855 5.95909 10.7318 5.71285 10.7318 5.40909C10.7318 5.10533 10.4855 4.85909 10.1818 4.85909L3.81812 4.85909Z"
            fill="currentColor"
          />
          <path
            d="M5.09085 6.76818C4.7871 6.76818 4.54085 7.01443 4.54085 7.31818C4.54085 7.62194 4.7871 7.86818 5.09085 7.86818H8.90904C9.21279 7.86818 9.45903 7.62194 9.45903 7.31818C9.45903 7.01443 9.21279 6.76818 8.90904 6.76818H5.09085Z"
            fill="currentColor"
          />
          <path
            d="M5.81358 9.22728C5.81358 8.92352 6.05982 8.67728 6.36358 8.67728H7.63631C7.94006 8.67728 8.18631 8.92352 8.18631 9.22728C8.18631 9.53103 7.94006 9.77728 7.63631 9.77728H6.36358C6.05982 9.77728 5.81358 9.53103 5.81358 9.22728Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.9999 7C13.9999 10.866 10.8659 14 6.99994 14C3.13395 14 -6.10352e-05 10.866 -6.10352e-05 7C-6.10352e-05 3.13401 3.13395 0 6.99994 0C10.8659 0 13.9999 3.13401 13.9999 7ZM12.8999 7C12.8999 10.2585 10.2584 12.9 6.99994 12.9C3.74146 12.9 1.09994 10.2585 1.09994 7C1.09994 3.74152 3.74146 1.1 6.99994 1.1C10.2584 1.1 12.8999 3.74152 12.8999 7Z"
            fill="currentColor"
          />
        </>
      ),
    },
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            d="M7 8.9C6.66863 8.9 6.4 9.16863 6.4 9.5C6.4 9.83137 6.66863 10.1 7 10.1L17 10.1C17.3314 10.1 17.6 9.83137 17.6 9.5C17.6 9.16863 17.3314 8.9 17 8.9L7 8.9Z"
            fill="currentColor"
          />
          <path
            d="M9 11.9C8.66863 11.9 8.4 12.1686 8.4 12.5C8.4 12.8314 8.66863 13.1 9 13.1H15C15.3314 13.1 15.6 12.8314 15.6 12.5C15.6 12.1686 15.3314 11.9 15 11.9H9Z"
            fill="currentColor"
          />
          <path
            d="M10.4 15.5C10.4 15.1686 10.6686 14.9 11 14.9H13C13.3314 14.9 13.6 15.1686 13.6 15.5C13.6 15.8314 13.3314 16.1 13 16.1H11C10.6686 16.1 10.4 15.8314 10.4 15.5Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM21.8 12C21.8 17.4124 17.4124 21.8 12 21.8C6.58761 21.8 2.2 17.4124 2.2 12C2.2 6.58761 6.58761 2.2 12 2.2C17.4124 2.2 21.8 6.58761 21.8 12Z"
            fill="currentColor"
          />
        </>
      ),
    },
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M42.75 24C42.75 34.3553 34.3553 42.75 24 42.75C13.6447 42.75 5.25 34.3553 5.25 24C5.25 13.6447 13.6447 5.25 24 5.25C34.3553 5.25 42.75 13.6447 42.75 24ZM44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24ZM14.5 18.8296C14.1548 18.8296 13.875 19.1094 13.875 19.4546C13.875 19.7998 14.1548 20.0796 14.5 20.0796L33.5 20.0796C33.8452 20.0796 34.125 19.7998 34.125 19.4546C34.125 19.1094 33.8452 18.8296 33.5 18.8296L14.5 18.8296ZM18.5 24.2842C18.1548 24.2842 17.875 24.564 17.875 24.9092C17.875 25.2544 18.1548 25.5342 18.5 25.5342H29.5C29.8452 25.5342 30.125 25.2544 30.125 24.9092C30.125 24.564 29.8452 24.2842 29.5 24.2842H18.5ZM21.375 30.3636C21.375 30.0185 21.6548 29.7386 22 29.7386H26C26.3452 29.7386 26.625 30.0185 26.625 30.3636C26.625 30.7088 26.3452 30.9886 26 30.9886H22C21.6548 30.9886 21.375 30.7088 21.375 30.3636Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
